import * as headerBlock from '../header/index';

export default {
  name: 'home',
  components: { headerBlock },
  props: [
    'onLogout',
    // 'authUser',
  ],
  mounted() {

  },
  data() {
    return {
      authUser: null,
      access_token: '',
      items: [
        [
          { name: 'Working areas', url: `${process.env.START_URL}/configuration/workingAreas`, active: true },
          { name: 'Days, times & Shifts', url: `${process.env.START_URL}/configuration/shifts` },
          { name: 'Users & Permissions', url: `${process.env.START_URL}/configuration/usersPermissions` },
          { name: 'Roles', url: `${process.env.START_URL}/configuration/roles` },
          { name: 'Settings', url: `${process.env.START_URL}/configuration/settings` }
        ],
        [
          { name: 'Task constructor', url: `${process.env.START_URL}/constructor/TaskConstructor` },
          { name: 'Task constructor (new)', url: `${process.env.START_URL}/constructor/new_task` },
          { name: 'Checklists constructor', url: `${process.env.START_URL}/constructor/ChecklistConstructor` },
          { name: 'Checklist constructor (new)', url: `${process.env.START_URL}/constructor/new_checklist` },
          { name: 'Audits constructor', url: `${process.env.START_URL}/constructor/AuditConstructor` },
          { name: 'Audit constructor (new)', url: `${process.env.START_URL}/constructor/new_audit` }
        ],
        [
          { name: 'Tasks', url: `${process.env.START_URL}/constructor/tasks` },
          { name: 'Tasks (new)', url: `${process.env.START_URL}/constructor/new_tasks` },
          { name: 'Checklists', url: `${process.env.START_URL}/constructor/checklists` },
          { name: 'Checklists (new)', url: `${process.env.START_URL}/constructor/new_checklists` },
          { name: 'Audits', url: `${process.env.START_URL}/constructor/audits` },
          { name: 'Audits (new)', url: `${process.env.START_URL}/constructor/new_audits` },
          { name: 'Actions', url: `${process.env.START_URL}/` }
        ],
      ],
      fields: [
        { name: { label: 'Configuration' } },
        { name: { label: 'Constructors' } },
        { name: { label: 'Data' } },
      ],
      breadCrumbItems: [
        {
          text: 'Companies',
          to: `${process.env.START_URL}/companies`,
        }, {
          text: 'Home',
          active: true,
        },
      ],
      // currentPage: 1,
      // perPage: 5,
      // filter: null,
    };
  },
  methods: {
    // redirect: function(url) {
    //   this.$router.push(url);
    // },

  },
  computed: {

  },
  created() {
    const token = localStorage.getItem('access_token');
    const authUser = localStorage.getItem('authUser');
    this.access_token = token || '';
    this.authUser = authUser ? JSON.parse(authUser) : null;
    if (this.authUser && this.authUser.role == 'shift_leader') {
      this.items.splice(0, 1);
      this.fields.splice(0, 1);
    }
  },
};




// WEBPACK FOOTER //
// ./src/components/home/home.component.js